const pushIfDataLayerExists = (data) => {
  if (!window.dataLayer) return
  window.dataLayer.push({
    event: 'booking_interaction',
    group: 'date_time',
    ...data,
  })
}

export const trackDateSelection = (isOutward) => {
  pushIfDataLayerExists({
    sub_group: 'selection_date',
    element_id: isOutward ? 'departure-date' : 'return-date',
    interaction_type: 'select',
    element_details: 'regular',
  })
}

export const trackCombinedSailModalOpened = (isOutward) => {
  pushIfDataLayerExists({
    sub_group: 'selection_date',
    element_id: isOutward ? 'departure-date' : 'return-date',
    interaction_type: 'open',
    element_details: 'travel_via_helsinki',
  })
}

export const trackCombinedSailStartBooking = ({ from, to }) => {
  pushIfDataLayerExists({
    sub_group: 'travel_via_helsinki',
    element_id: 'start_booking',
    element_details: [from, to].join('-').toLowerCase(),
  })
}

export const trackThanksForTheInfoClick = () => {
  pushIfDataLayerExists({
    sub_group: 'travel_via_helsinki',
    element_id: 'thanks_for_the_info',
  })
}
